// firebase.js — Firebase app init + shared handles. ESM replacement for the
// old firebase-config.js template + <script> tag: the config now comes from
// FIREBASE_* env vars at build time (vite.config.js envPrefix) — the SAME
// names the Cloudflare Pages project already sets, and the same .env file for
// local dev (Vite loads it automatically).
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

const env = import.meta.env || {};
const firebaseConfig = {
  apiKey:            env.FIREBASE_API_KEY,
  authDomain:        env.FIREBASE_AUTH_DOMAIN,
  projectId:         env.FIREBASE_PROJECT_ID,
  storageBucket:     env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.FIREBASE_MESSAGING_SENDER_ID,
  appId:             env.FIREBASE_APP_ID,
  measurementId:     env.FIREBASE_MEASUREMENT_ID,
};

// Guarded init: under tests/tooling there is no config, and engine modules
// that import this file must still load — the handles stay null and are only
// dereferenced at runtime in the browser. build.js fails a production build
// up front when the env vars are missing, so a broken deploy can't happen
// silently.
const enabled = !!firebaseConfig.apiKey;
if (enabled) firebase.initializeApp(firebaseConfig);

export { firebase };
export const fbAuth    = enabled ? firebase.auth()      : null;
export const fbDb      = enabled ? firebase.firestore() : null;
export const fbStorage = enabled ? firebase.storage()   : null;

// Console tools (__migrateJobInvoices etc.) and ad-hoc debugging still expect
// the window handles the old firebase-config.js provided.
if (typeof window !== 'undefined') Object.assign(window, { firebase, fbAuth, fbDb, fbStorage });
